import { defineAsyncComponent } from 'vue'
export default {
  default: defineAsyncComponent(() => import("/app/layouts/default.vue").then(m => m.default || m)),
  simple: defineAsyncComponent(() => import("/app/layouts/simple.vue").then(m => m.default || m))
}